import { Divider, Typography } from '@mui/material'
import ButtonCustom from '../../../component/button/buttonCustom'
import { useLocation, useNavigate } from 'react-router-dom';
import InputPasswordField from '../../../component/input/inputPasswordField';
import LoginApi from '../../../api/auth/auth.api';
import { swalError, swalSuccess } from '../../../component/notification/swal';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
const initStateErrorMessage = {
    PASSWORD: "",
    PASSWORD_CONFIRM: "",
};
export default function ConfimPassword() {
    const { t } = useTranslation();
    const location = useLocation()
    const { atoken } = location.state
    const [password, setPassword] = useState<string>("");
    const [passwordConfirm, setPasswordConfirm] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<any>(initStateErrorMessage);
    const clearErrorMessage = () => setErrorMessage(initStateErrorMessage);

    const submit = async () => {
        if (!password)
            return setErrorMessage({
                ...errorMessage,
                ...{ PASSWORD: t('CONFIMPASSORD.MESSAGE.PASSWORD') },
            });
        if (!passwordConfirm)
            return setErrorMessage({
                ...errorMessage,
                ...{ PASSWORD_CONFIRM: t('CONFIMPASSORD.MESSAGE.CONFIMPASSORD') },
            });
        if (password !== passwordConfirm)
            return setErrorMessage({
                ...errorMessage,
                ...{ PASSWORD_CONFIRM: t('CONFIMPASSORD.MESSAGE.MATCHPASSORD') },
            });
        setLoading(true);

        await LoginApi.resetPassword(password, atoken)
            .then(async ({ data }) => {
                if (data.result) {
                    setLoading(false);
                    swalSuccess(t('CONFIMPASSORD.SWAL.CONFIMPASSORDSUCCESS'), 'go', '/login')
                } else {
                    swalError(data.description);
                }
            })
            .catch((e) => {
                setLoading(false);
                swalError(e.response.data.description || e.response.data.message);
            })
            .finally(() => {
                setLoading(false);
            })
    };
    return (
        <>
        <div style={{
            width: "100%",
            gap: '16px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }}>
            <Divider orientation="horizontal" flexItem>
                <Typography sx={{ color: '#858C95' }}>{t('CONFIMPASSORD.TITLE')}</Typography>
            </Divider>
            <InputPasswordField
                heading={`${t('CONFIMPASSORD.INPUT.PASSWORD')}*`}
                inputProps={{ startAdornment: null }}
                onchange={(event) => {
                    setPassword(event.target.value);
                    clearErrorMessage();
                }}
                helperText={
                    errorMessage.PASSWORD || ''
                } />

            <InputPasswordField
                heading={`${t('CONFIMPASSORD.INPUT.CONFIMPASSORD')}*`}
                inputProps={{ startAdornment: null }} onchange={(event) => {
                    setPasswordConfirm(event.target.value);
                    clearErrorMessage();
                }}
                helperText={
                    errorMessage.PASSWORD_CONFIRM || ''
                } />

        </div>
        <ButtonCustom
            type="submit"
            onClick={() => {
                submit()
            }}
            disabled={loading}
            textButton={t('OTPCONFIM.BUTTON.SUBMMIT')}
            btnStyle={{
                fontSize: "16px",
                width: "100%",
            }}
            style={{ width: "100%", }}
        />
    </>
    )
}
